import React from "react";
import styles from "./HomeDownloadApp.module.scss";
import TwoPhones from "./assets/twoPhones.svg";
import AppleIcon from "./assets/apple-logo.svg";
import Star from "./assets/star.svg";
import PlayLogo from "./assets/google-play.svg";
import OrangeQr from "./assets/bi_qr-code.svg";
import Dots from "./assets/dots.svg";
import BottomLIcon from "./assets/bottomleft.svg";
import Triangles from "./assets/triangles.svg";
import BlueQR from "./assets/bx_bx-qr-scan.svg";
import { motion } from "framer-motion";
const {
  download,
  content,
  footer,
  imgside,
  textside,
  dots,
  shapes,
  triangles,
} = styles;
const DownloadApp = () => {
  return (
    <section className={download}>
      <img src={Dots} className={dots} alt="Dots" />
      <img src={Triangles} className={triangles} alt="Triangle shapes" />
      <img
        src={BottomLIcon}
        className={shapes}
        alt="Shapes brought together to look nice "
      />
      <div className={`${content} global-lr-pad`}>
        <motion.div
          className={textside}
          initial={{
            x: "-14rem",
            opacity: 0,
          }}
          whileInView={{
            x: 0,
            opacity: 1,
            transition: {
              duration: 0.7,
              type: "tween",
            },
          }}
        >
          <p>SHOP - PAY -SAVE</p>
          <h2>Download our app to get started today!</h2>
          <p>
            End-to-end payments and financial management in a single solution.
          </p>
          <div>
            <button>
              <img src={AppleIcon} alt="Apple Store" />
              <span>Apple store </span>
            </button>
            <button>
              <img src={PlayLogo} alt="Play Store" />
              <span>Play store </span>
            </button>
          </div>
        </motion.div>
        <motion.div
          className={imgside}
          initial={{
            x: "14rem",
            opacity: 0,
          }}
          whileInView={{
            x: 0,
            opacity: 1,
            transition: {
              duration: 0.7,
              type: "tween",
              delay: 0.7,
            },
          }}
        >
          <img src={TwoPhones} alt="We quick pay app on phone " />
        </motion.div>
      </div>
      <motion.div
        className={footer}
        initial={{
          y: "4rem",
          opacity: 0,
        }}
        whileInView={{
          y: 0,
          opacity: 1,
          transition: {
            duration: 0.5,
            type: "tween",
            delay: 0.4,
          },
        }}
      >
        <div>
          <h1>
            <span>Make</span> <span>or</span> <span>Recieve</span>
          </h1>
          <p>payment in few steps</p>
        </div>
        <div>
          <img src={Star} alt="Star" />
          <span>Open App</span>
        </div>
        <div>
          <img src={OrangeQr} alt="QR SCanner" />
          <p>
            Generate QR Code <br />
            to receive payment
          </p>
        </div>
        <div>
          <img src={BlueQR} alt="QR SCanner" />
          <p>
            Generate QR Code <br />
            to receive payment
          </p>
        </div>
      </motion.div>
    </section>
  );
};

export default DownloadApp;
